import { ArrowRightOutlined, LoadingOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { changeToken } from '../../../app/store/authStore';
import { changeUser } from '../../../app/store/userStore';
import { FormItemInput, Button } from '../../../components/index';
import { LayoutLogin } from '../../../components/common/layoutLogin/LayoutLogin';
import { useLoginMutation } from '../../../services/authApi';
import { LoginType } from '../../../types';
import { Form, Title, Footer, ButtonForgotPassword } from './styles';
import { useBranding } from '../../../context/brandingContext';

export default function SignIn() {
  const { branding } = useBranding();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [login, { isLoading: isLoadingLogin }] = useLoginMutation();

  async function onFinish(values: any) {
    const userData: LoginType = {
      email: values.email,
      password: values.password,
    };

    const response = await login(userData);

    if ('data' in response) {
      // Verifica se o 2FA está ativo e requer verificação
      if (response.data.requires_2fa) {
        // Persiste no sessionStorage para sobreviver a recarregamentos
        sessionStorage.setItem(
          '2fa_challenge',
          JSON.stringify({
            challenge_id: response.data.challenge_id,
            user_id: response.data.user_id,
            trusted_devices_enabled: response.data.trusted_devices_enabled,
          })
        );
        navigate('/verify-2fa', {
          state: {
            challenge_id: response.data.challenge_id,
            user_id: response.data.user_id,
            trusted_devices_enabled: response.data.trusted_devices_enabled,
          },
        });
        return;
      }

      // Login normal sem 2FA
      if ('user' in response.data) {
        dispatch(changeUser(response.data.user));
        dispatch(changeToken(response.data));
        navigate('/');
      }
    }
  }

  return (
    <LayoutLogin>
      <Form onFinish={onFinish} layout="vertical" requiredMark="optional">
        <Title>{branding?.loginMessage || 'Bem-vindo'}</Title>
        <div>
          <FormItemInput
            label="Nome do Usuário"
            name="email"
            type="email"
            required
            requiredMessage="Informe seu Usuário"
            disabled={isLoadingLogin}
            placeholder="usuario@email.com"
          />
          <FormItemInput
            label="Senha"
            name="password"
            type="password"
            required
            requiredMessage="Informe seu senha"
            disabled={isLoadingLogin}
            placeholder="******"
          />
          <Footer>
            <ButtonForgotPassword
              onClick={() => navigate('/forgot-my-password')}
            >
              Esqueceu a senha?
            </ButtonForgotPassword>
            <Form.Item>
              <Button
                style={{ width: '106px', height: '40px' }}
                type="primary"
                htmlType="submit"
                block
                icon={!isLoadingLogin && <ArrowRightOutlined />}
              >
                {isLoadingLogin ? <LoadingOutlined /> : 'Entrar'}
              </Button>
            </Form.Item>
          </Footer>
        </div>
      </Form>
    </LayoutLogin>
  );
}
